export const css = {
    root: 'VDwC0QPb',
    slideIn: '_6dtCOC4X',
    slideOut: 'oROL-fbd',
    underlayVisible: 'wJ4k9OHw',
    content: 'eB4TEa5l',
    pane: 'M2zAIfkx',
    title: '_9Ardg-Pv',
    titleContent: 'cPLJyShu',
    close: 'fPdyv7JU',
    closeIcon: 'y28ChI6C',
    left: 'xD1dV1wX',
    right: 'wLfuYrJn',
    top: 'I5yf72SL',
    bottom: 'x7faCi5Q',
    open: 'UxxKcTf6',
    ' _key': 'table-of-contents/sliding-pane'
};
export default css;
